import { render, staticRenderFns } from "./ListadoEmailsEstadisticasComunicados.vue?vue&type=template&id=2a16b690"
import script from "./ListadoEmailsEstadisticasComunicados.vue?vue&type=script&lang=js"
export * from "./ListadoEmailsEstadisticasComunicados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports